import React from "react";

// Сброс состояния активности (была нажата) для Button из antd
export default function hideButtonVisitMark(e: React.MouseEvent): void {
  if (e) {
    // @ts-ignore
    e.target.closest("button").blur();
  }
}
